import { render, staticRenderFns } from "./ProjectQuickActions.vue?vue&type=template&id=67440896"
import script from "./ProjectQuickActions.vue?vue&type=script&lang=js"
export * from "./ProjectQuickActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports